
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const onShowNoTrackingIcon = (props) => {
    const handleGPSClick = (e) => {
        e.stopPropagation();
        if (style.no_gps_data === "#cccc") {
            return; // Exit early if the color is gray
        }
        if (style.no_gps_data === "#FF5370") {
            return; // Exit the function early if the condition is met
        }
        if (style.no_gps_data === "#26c6da") {
            return; // Exit the function early if the condition is met
        }

    
        props.onShowNoGPSData(props)
    };
    const style = {
        no_gps_data: "#cccc",
      
    }
    
    if ((props?.data?.no_tracking_data != undefined && props?.data?.no_tracking_data == 1) && (props.data.consignment_status !=="Delivered" || props.data.status !==8 || props.data.status !==4)) {
        style["no_gps_data"] = "#FF5370"
    }
    // if ((props?.data?.no_tracking_data != undefined && ((new Date().getTime() -new Date(props.data.last_process_on))/(1000 * 3600 * 24)) > 1) && (props.data.consignment_status !=="Delivered" || props.data.status !==8 || props.data.status !==4) ){
    //     style["no_gps_data"] = "#FF5370"
    // }
    else if (props?.data?.no_tracking_data != undefined && props?.data?.no_tracking_data == 0) {
        style["no_gps_data"] = "#26c6da"
    }

    return (
        <div className="map-icon-component">
            {/*<button onClick={handleClick} className="custom-btn label label-success" title="View Timeline"><i className="icofont icofont-tree-alt"></i> Timeline </button>
            &nbsp;| &nbsp;
            */}
 {/* { props.hasUpload !==1 ? (
                <button onClick={handleRouteClick} className="custom-btn label label-success" title="Shipment Legs">
                    <i className="icofont icofont-site-map f20"></i> 
                </button>
            ): (<button onClick={handleRouteClick}  style={{border:"none", backgroundColor:"transparent",
                pointerEvents: props.disabled ? "none" : "auto", 
                opacity: props.disabled ? 0.5 : 1, }}className="custom-btn label label-success" title="Upload POD Inside">
<button className="icon-square" style={{color:"green"}}>
    <i className="icofont icofont-arrow-right" style={{color:"green"}}></i>
</button>        </button>)}        */}
 <span onClick={handleGPSClick} title={props.data.tracking_type === "PTL" ? "Tracking N/A":"Tracking N/A"}>
                        <i className="icofont icofont-social-google-map f18" style={{ color: style.no_gps_data }}></i>
                    </span>
        </div>
    );
};

export default onShowNoTrackingIcon;
